const BaseURL = "https://craneiq.univa.cloud/"
// const BaseURL = "http://localhost:9030/"

export default BaseURL;